import {
  AbsolutePoint,
  Point,
} from '@app/features/apply-react-signing/components/FieldRenderer/types';

export function createAbsolutePoint(point: Point): AbsolutePoint {
  return point as AbsolutePoint;
}
